import { render } from "./admin-reset.vue?vue&type=template&id=79701203&scoped=true"
import script from "./admin-reset.vue?vue&type=script&lang=js"
export * from "./admin-reset.vue?vue&type=script&lang=js"

import "./admin-reset.vue?vue&type=style&index=0&id=79701203&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79701203"]])

export default __exports__